import * as React from 'react'
import type { SVGProps } from 'react'

interface SvgLockProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const ACTIVE_COLOR = '#002A73'
const INACTIVE_STROKE_COLOR = '#CECECE'
const INACTIVE_FILL_COLOR = '#8D8D8D'

const ICON_SIZE = 28
const VIEW_BOX = '0 0 28 28'

const highlightPathD =
  'M22.75 9.625H5.25C4.76675 9.625 4.375 10.0168 4.375 10.5V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V10.5C23.625 10.0168 23.2332 9.625 22.75 9.625Z'
const lockBodyPathD =
  'M22.75 9.625H5.25C4.76675 9.625 4.375 10.0168 4.375 10.5V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V10.5C23.625 10.0168 23.2332 9.625 22.75 9.625Z'
const keyholePathD =
  'M14 17.9375C14.7249 17.9375 15.3125 17.3499 15.3125 16.625C15.3125 15.9001 14.7249 15.3125 14 15.3125C13.2751 15.3125 12.6875 15.9001 12.6875 16.625C12.6875 17.3499 13.2751 17.9375 14 17.9375Z'
const shacklePathD =
  'M9.625 9.625V6.125C9.625 4.96468 10.0859 3.85188 10.9064 3.03141C11.7269 2.21094 12.8397 1.75 14 1.75C15.1603 1.75 16.2731 2.21094 17.0936 3.03141C17.9141 3.85188 18.375 4.96468 18.375 6.125V9.625'

const SvgLock = ({
  isActive = false,
  stroke,
  width,
  height,
  ...props
}: SvgLockProps) => {
  const currentStrokeColor = isActive
    ? ACTIVE_COLOR
    : stroke || INACTIVE_STROKE_COLOR

  const keyholeFillColor = isActive ? ACTIVE_COLOR : INACTIVE_FILL_COLOR

  return (
    <svg
      {...props}
      width={width ?? ICON_SIZE}
      height={height ?? ICON_SIZE}
      viewBox={VIEW_BOX}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {isActive && (
        <path opacity='0.2' d={highlightPathD} fill={ACTIVE_COLOR} />
      )}

      <path
        d={lockBodyPathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path d={keyholePathD} fill={keyholeFillColor} />

      <path
        d={shacklePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SvgLock
